import React, { useState, useEffect } from "react";
import {
  Badge,
  Container,
  Nav,
  Navbar,
  Dropdown,
  Button,
} from "react-bootstrap";

import logo from "../Assets/Images/logo.png";
import logoHindi from "../Assets/Images/logohindi.png";
import "../css/header.css";
import Login from "./Login";
import UserAddress from "./UserAddress";
import Profile from "./Profile";
import Cart from "./Cart";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ApplicationContext } from "../Context/AppContext";
import FullPageLoader from "./FullPageLoader";
import MessageModal from "./MessageModal";
import {
  getSeedCategories,
  getNav_Menu,
  getCompany_Info,
  getCart_Data,
  getUserProfile,
} from "./../Services/client";
import { gaCartOpen } from "../utils/analytics";

const Headers = ({ scrollToSection, aboutusRef, contactusRef }) => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showUserAddress, setShowUserAddress] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [categories, setCategories] = useState([]);
  const [navMenu, setNavMenu] = useState({ menu: [], uncategorized: [] });
  const [companyInfo, setCompanyInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [userImg, setUserImg] = useState(null);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount, fetchData, setCartCount } = ApplicationContext();

useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getCategories();
    getCompanyInfo();
    loadNavMenu();
  }, [localStorage.getItem("i18nextLng")]);

  useEffect(() => {
    const mobile = localStorage.getItem("userMobile");
    if (!mobile) return;
    getUserProfile(mobile).then((res) => {
      const profile = res?.data?.profile;
      if (profile?.name) setDisplayName(profile.name);
      if (profile?.user_img) setUserImg(profile.user_img);
    }).catch(() => {});
  }, []);

  const loadNavMenu = async () => {
    const lng = localStorage.getItem("i18nextLng") || "en";
    const res = await getNav_Menu(lng);
    if (res?.data?.success) {
      setNavMenu({
        menu: res.data.data.menu || [],
        uncategorized: res.data.data.uncategorized || [],
      });
    }
  };

  const getCategories = async () => {
    const lng = localStorage.getItem("i18nextLng");
    if (lng !== "en" && lng !== "hi") {
      i18n.changeLanguage("en");
    }

    const catResponse = await getSeedCategories(lng);
    if (catResponse?.data?.data?.length && catResponse.status === 200) {
      setCategories(catResponse.data.data);
    }
  };

  const getCompanyInfo = async () => {
    const companyInfo = await getCompany_Info();
    if (companyInfo?.data?.data?.length && companyInfo.status === 200) {
      setCompanyInfo(companyInfo.data.data);
    }
  };

  const showUserAdd = (show) => {
    setShowUserAddress(show);
  };

  const closUserAdd = () => {
    setShowUserAddress(false);
  };

  const showItemCart = () => {
    gaCartOpen();
    // Cart can remain mounted (but visually closed) after a Razorpay
    // payment attempt finishes, so `showCart` here may already be `true`
    // — setShowCart(true) would then be a no-op and the cart wouldn't
    // reopen. Force a real false->true transition so Cart always
    // unmounts/remounts fresh on every badge click.
    setShowCart(false);
    setTimeout(() => setShowCart(true), 0);
  };

  const closeItemCart = () => {
    setShowCart(false);
  };

  const changeLanguage = (lng) => {
    setIsLoading(true);
    i18n.changeLanguage(lng);
    setTimeout(() => {
      fetchData(lng);
      getCartData();
      setIsLoading(false);
    }, 2000);
  };

  const handleAboutUsClick = () => {
    if (location.pathname === "/") {
      scrollToSection(aboutusRef);
    } else {
      navigate("/", { state: { scrollTo: "aboutus" } });
    }
  };

  const viewProducts = (categoryId, categoryName) => {
    navigate("/products", {
      state: { categoryId: categoryId, categoryName: categoryName },
    });
  };

  const viewParentProducts = (pcId, parentName) => {
    setShowSubmenu(false);
    navigate("/products", { state: { pc_id: pcId, parentName } });
  };

  const shouldRedirectDirectly = (group) => {
    if (!group || group.categories.length === 0) return true;
    return group.categories.every(
      (cat) => cat.category_title?.toLowerCase().trim() === "no category"
    );
  };

  const logout = () => {
    localStorage.removeItem("userAddress");
    localStorage.removeItem("userId");
    localStorage.removeItem("userMobile");
    localStorage.removeItem("userName");
    localStorage.removeItem("token");
    localStorage.removeItem("cartItems");
    localStorage.removeItem("deliveryAddress");
    setCartCount(0);
    setDisplayName("");
    setUserImg(null);
    navigate("/");
    setShowModal(false);
  };

  const confirmLogout = () => {
    setShowModal(true);
  };

  const getCartData = async () => {
    const userId = localStorage.getItem("userId") || 0;
    const lng = localStorage.getItem("i18nextLng");
    if (lng !== "en" && lng !== "hi") {
      i18n.changeLanguage("en");
    }
    if (userId === 0) return;
    const cartResponse = await getCart_Data(userId, lng);
    if (cartResponse.success === false) {
      console.log("Failed to load cart data");
    } else {
      const returnData = cartResponse?.data?.cartData;
      if (returnData?.length > 0) {
        let liveCartData = returnData?.map((cart, idx) => {
          return {
            productId: cart.productId,
            name: cart.productName,
            price: parseFloat(cart.price).toFixed(2),
            qty: cart.qty,
            img: { id: cart.imgId, url: cart.imgUrl },
            detailId: cart.detailId,
            unit: cart.unit,
            isAdjusted: cart.isAdjusted,
            availQty: cart.availQty,
            unitQty: cart.unitQty,
          };
        });
        localStorage.removeItem("cartItems");
        localStorage.setItem("cartItems", JSON.stringify(liveCartData));
        const totalQty = liveCartData.reduce(
          (sum, item) => sum + (item.qty || 0),
          0,
        );
        setCartCount(totalQty);
        console.log("Cart updated successfully!");
      }
    }
  };

  return (
    <>
      <div className=" text-dark topbar">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-3 text-center text-md-start mb-2 mb-md-0">
              <Link to="/">
                <img
                  src={i18n.language === "hi" ? logoHindi : logo}
                  alt="Logo"
                  className="headerlogo d-inline-block align-top me-3"
                />
              </Link>
            </div>

            <div className="col-12 col-md-7 text-center text-md-center mt-2"></div>

            <div className="col-12 col-md-2 text-center text-md-center mb-2 mb-md-0">
              <div
                className="language-switcher"
                style={{
                  marginTop: "7px",
                  display: "inline-flex",
                  gap: "10px",
                }}
              >
                <span
                  onClick={() => changeLanguage("en")}
                  className="language-font"
                  style={{
                    cursor: "pointer",
                    fontWeight: i18n.language === "en" ? "bold" : "normal",
                  }}
                >
                  English
                </span>
                <span className="language-font">|</span>
                <span
                  onClick={() => changeLanguage("hi")}
                  className="language-font"
                  style={{
                    cursor: "pointer",
                    fontWeight: i18n.language === "hi" ? "bold" : "normal",
                  }}
                >
                  हिंदी
                </span>
              </div>
            </div>
          </div>
          <div className="row align-items-center"></div>
        </div>
      </div>
      <div className={`sticky-header ${scrolled ? "scrolled" : ""}`}>
        <Navbar expand="lg" style={{ borderBottom: "1px solid #dcdcdc" }}>
          <Container>
            <Navbar.Brand href="/"></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <div className="d-flex w-100 justify-content-between align-items-center">
                <Nav className="flex-grow-1 justify-content-center align-items-center">
                  <Nav.Link href="/" className="navlink mx-2">
                    {t("home")}
                  </Nav.Link>
                  <Nav.Link
                    onClick={() => handleAboutUsClick()}
                    className="navlink mx-2"
                  >
                    {t("aboutus")}
                  </Nav.Link>
                  <div
                    className="nav-link submenu-container position-relative"
                    onMouseEnter={() => setShowSubmenu(true)}
                    onMouseLeave={() => setShowSubmenu(false)}
                  >
                    <Nav.Link className="navlink navLinkSeeds mx-2">
                      {t("seeds")} <i className="fa fa-caret-down"></i>
                    </Nav.Link>
                    {showSubmenu && (
                      <div className="submenu">
                        {navMenu.menu.map((group) => {
                          const direct = shouldRedirectDirectly(group);
                          const children = group.categories.filter(
                            (cat) => cat.category_title?.toLowerCase().trim() !== "no category"
                          );
                          return (
                            <div key={group.pc_id} className="submenu-parent-item">
                              <div
                                className="submenu-parent-label"
                                style={{ cursor: direct ? "pointer" : "default" }}
                                onClick={direct ? () => viewParentProducts(group.pc_id, group.parent_name) : undefined}
                              >
                                {group.parent_name}
                                {!direct && <i className="fa fa-caret-right" />}
                              </div>
                              {!direct && children.length > 0 && (
                                <div className="submenu-children">
                                  {children.map((cat) => (
                                    <Nav.Link
                                      key={cat.id}
                                      className="submenu-link"
                                      onClick={() => viewProducts(cat.id, cat.category_title)}
                                    >
                                      {cat.category_title}
                                    </Nav.Link>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                        {navMenu.uncategorized.map((cat) => (
                          <Nav.Link
                            key={cat.id}
                            className="submenu-link"
                            onClick={() => viewProducts(cat.id, cat.category_title)}
                          >
                            {cat.category_title}
                          </Nav.Link>
                        ))}
                      </div>
                    )}
                  </div>
                  <Nav.Link
                    onClick={() => scrollToSection(contactusRef)}
                    className="navlink mx-2"
                  >
                    {t("contactus")}
                  </Nav.Link>
                </Nav>
              </div>
            </Navbar.Collapse>

            <div className="d-flex align-items-center icon-bar-container">
              {/* <input
                type="text"
                placeholder={t("search")}
                className="form-control me-4"
                style={{ maxWidth: "200px" }}
              /> */}
              <div
                className="position-relative me-4"
                style={{ cursor: "pointer" }}
                onClick={() => showItemCart()}
              >
                <i className="fas fa-shopping-cart fs-5 text-dark"></i>
                <Badge
                  bg="danger"
                  pill
                  className="position-absolute top-0 start-100 translate-middle"
                  style={{ fontSize: "0.6rem" }}
                >
                  {localStorage.getItem("userMobile") ? (cartCount || 0) : 0}
                </Badge>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-user"
                  className="p-0 border-0 bg-transparent"
                >
                  {userImg ? (
                    <img
                      src={userImg}
                      alt="Profile"
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid #28a745",
                      }}
                    />
                  ) : (
                    <i className="fas fa-user fs-5 text-dark"></i>
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-user-dropdown">
                  {localStorage.getItem("userMobile") && (
                    <Dropdown.Item>
                      <div style={{ textAlign: "center" }}>
                        {userImg && (
                          <img
                            src={userImg}
                            alt="Profile"
                            style={{
                              width: 52,
                              height: 52,
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "2px solid #28a745",
                              marginBottom: 6,
                              display: "block",
                              margin: "0 auto 6px",
                            }}
                          />
                        )}
                        <p style={{ margin: 0 }}>
                          {t("welcome_user")}
                        </p>
                        <p style={{ margin: 0, color: "red" }}>
                          {displayName
                            ? displayName.charAt(0).toUpperCase() + displayName.slice(1)
                            : localStorage.getItem("userMobile")}
                        </p>
                      </div>
                      <hr></hr>
                    </Dropdown.Item>
                  )}
                  {localStorage.getItem("cartItems") &&
                    !localStorage.getItem("userMobile") && (
                      <Dropdown.Item>
                        <p style={{ textAlign: "center", color: "red" }}>
                          {t("welcome_guest_user")}
                        </p>
                        <hr />
                      </Dropdown.Item>
                    )}
                  {!localStorage.getItem("userMobile") && (
                    <Dropdown.Item onClick={() => setShowLogin(true)}>
                      {t("login")}
                    </Dropdown.Item>
                  )}

                  {localStorage.getItem("userMobile") && (
                    <>
                      <Dropdown.Item onClick={() => setShowProfile(true)}>
                        {t("profile")}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setShowUserAddress(true)}>
                        {t("add_address")}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => navigate("/trackorder")}>
                        {t("track_order")}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => confirmLogout()}>
                        {t("logout")}
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Container>
        </Navbar>
      </div>
      {showLogin ? (
        <Login
          show={showLogin}
          setShowLogin={() => {
            setShowLogin();
          }}
          // showSignup={showSignup}
          callback={(needsProfile) => {
            if (needsProfile) {
              setTimeout(() => setShowProfile(true), 600);
            }
          }}
        />
      ) : null}
      {showUserAddress ? (
        <UserAddress
          show={showUserAdd}
          closeSignupForm={closUserAdd}
          callback={() => {}}
        />
      ) : null}
      {showProfile ? (
        <Profile
          show={showProfile}
          closeProfileForm={() => setShowProfile(false)}
          callback={(result) => {
            if (result?.name) setDisplayName(result.name);
            if (result?.imgUrl !== undefined) setUserImg(result.imgUrl);
          }}
        />
      ) : null}
      {showCart ? <Cart show={showCart} closeItemCart={closeItemCart} /> : null}
      {isLoading && <FullPageLoader />}
      <MessageModal
        show={showModal}
        title={t("logout")}
        message={t("logout_msg")}
        type={t("confirm")}
        onConfirm={logout}
        onCancel={() => setShowModal(false)}
      />
    </>
  );
};

export default Headers;
